<template>
  <lightbox
    ref="lightboxRef"
    :initial-index="0"
    :images="images"
  />

  <report-top-row />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="grid grid3">
          <report-user
            :report="report"
          />

          <report-status />
          <div />
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <report-image 
            :images="images"
            @lightbox-requested="onLightboxRequested"
          />
        </div>
        <div class="col-4">
          <report-message
            :report="report"
          />

          <report-comment />
          <!-- <report-forward
            :report="report"
          /> -->
        </div>
        <div class="col-4">
          <report-information />
        </div>
      </div>
    </div>
  </div>
  <report-log />
</template>

<script>
import Lightbox from '@/components/Shared/Lightbox/Lightbox.vue';
import ReportComment from '@/components/Reports/Details/Comment.vue';
//import ReportForward from '@/components/Reports/Details/Forward.vue';
import ReportImage from '@/components/Reports/Details/Image.vue';
import ReportInformation from '@/components/Reports/Details/Information/Information.vue';
import ReportLog from '@/components/Reports/Details/Log.vue';
import ReportMessage from '@/components/Reports/Details/Message.vue';
import ReportTopRow from '@/components/Reports/Details/TopRow.vue';
import ReportStatus from '@/components/Reports/Details/Status.vue';
import ReportUser from '@/components/Reports/Details/User.vue';
import { getById } from '@/api/providers/reports';

import ReportDetailStore from '@/store/pages/Report/report-detail-store';

export default {
  components: {
    Lightbox,
    ReportComment,
    //ReportForward,
    ReportImage,
    ReportInformation,
    ReportLog,
    ReportMessage,
    ReportTopRow,
    ReportStatus,
    ReportUser
  },

  data() {
    return {
      showUpdateButton: false
    };
  },

  computed: {
    report: () => ReportDetailStore.getters.report,
    images: () => ReportDetailStore.getters.images ?? [],
  },

  async mounted() {
    await ReportDetailStore.dispatch('loadReport', this.$route.params.id);
  },

  methods: {
    async fetchItem() {
      try {
        this.report = await getById(
          this.$route.params.id
        );
      } catch {
        return;
      }
    },

    onLightboxRequested(index) {
      this.$refs['lightboxRef'].show(index);
    }
  }
}
</script>
